import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { ExternalLink } from "lucide-react";
import { Card, CardContent, CardFooter } from "../ui/card";

const completedProjects = [
  {
    title: "Musical Meet",
    url: "musicalmeet.com",
    description: "A vibrant community platform connecting music enthusiasts, artists, and event organizers in a seamless digital ecosystem.",
    color: "from-purple-500 to-pink-500",
  },
  {
    title: "Kiwaad",
    url: "kiwaad.org",
    description: "A dedicated non-profit organization website , it focused on social change, community outreach, and transparent impact reporting.",
    color: "from-emerald-500 to-teal-500",
  },
  {
    title: "Clotch",
    url: "www.clotch.in",
    description: "An innovative fashion platform bringing fresh perspectives to the clothing and style industry.",
    color: "from-orange-500 to-red-500",
  },
];

export default function Portfolio() {
  const handleVisitProject = (url: string) => {
    window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="portfolio" className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        {/* Completed Projects Section */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-4">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">Selected Work</h2>
            <p className="text-muted-foreground text-lg">
              See how we've helped our partners achieve their digital goals.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {completedProjects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <Card className="overflow-hidden border-none shadow-md hover:shadow-xl transition-all duration-300 group h-full flex flex-col">
                <div className={`h-48 bg-gradient-to-br ${project.color} relative flex items-center justify-center`}>
                   <span className="text-white font-display font-bold text-3xl opacity-90">{project.title}</span>
                   <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-300" />
                </div>
                <CardContent className="pt-6 flex-grow">
                  <h3 className="text-2xl font-bold mb-2">{project.title}</h3>
                  <p className="text-muted-foreground mb-4">{project.description}</p>
                </CardContent>
                <CardFooter>
                   <Button 
                     variant="ghost" 
                     className="w-full justify-between group-hover:text-primary cursor-pointer"
                     onClick={() => handleVisitProject(project.url)}
                   >
                     Visit {project.url} <ExternalLink className="w-4 h-4" />
                   </Button>
                </CardFooter>
              </Card>
            </motion.div>
          ))}
        </div>


      </div>
    </section>
  );
}
